import React, { useState, useEffect } from "react";
import Button from "../../components/button/button";
import Input from "../../components/input/input";
import "./myDevices.css"; // Import the CSS file
import axios from "axios";
import BASE_URL from "../../config";

const MyDevices = () => {
  const [devices, setDevices] = useState([]);
  const [cases, setCases] = useState([]);
  const [deviceId, setDeviceId] = useState("");
  const [caseKey, setCaseKey] = useState("");
  // const [showForm, setShowForm] = useState(false);
  const [showCaseForm, setShowCaseForm] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  const fetchDevices = async () => {
    try {
      const token = localStorage.getItem("jwt_token");

      if (!token) {
        setMessage("Please log in first.");
        setMessageType("error");
        return;
      }

      const response = await axios.post(
        `${BASE_URL}/api/get_cust_devices/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setDevices(response.data);
      } else {
        setMessage("Error: " + response.data.detail);
        setMessageType("error");
      }
    } catch (error) {
      console.error(error);
      setMessage("No Devices Fetched");
      setMessageType("error");
    }
  };

  const fetchCases = async () => {
    try {
      const token = localStorage.getItem("jwt_token");
      if (!token) return;

      const response = await axios.get(`${BASE_URL}/api/pocket/my-case/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const data = response.data;
        setCases(Array.isArray(data) ? data : [data]);
      }
    } catch (error) {
      console.error("No cases fetched:", error);
    }
  };

  useEffect(() => {
    fetchDevices();
    fetchCases();
  }, []);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  // const handleAddDevice = async () => {
  //   setShowForm(false);
  //   try {
  //     const token = localStorage.getItem("jwt_token");
  //     if (!token) {
  //       setMessage("Please log in first.");
  //       setMessageType("error");
  //       return;
  //     }
  //     const response = await axios.post(
  //       `${BASE_URL}/api/serial_customer/`,
  //       { device_key: deviceId },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       setMessage(response.data.message);
  //       setMessageType("success");
  //       fetchDevices();
  //     } else {
  //       setMessage("Error: " + response.data.message);
  //       setMessageType("error");
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.status === 400) {
  //       setMessage("Error: " + error.response.data.error);
  //       setMessageType("error");
  //     } else {
  //       console.error(error);
  //       setMessage("Device key not found or conditions not met.");
  //       setMessageType("error");
  //     }
  //   }
  // };

  const handleAddCase = async () => {
    setShowCaseForm(false);
    try {
      const token = localStorage.getItem("jwt_token");

      if (!token) {
        setMessage("Please log in first.");
        setMessageType("error");
        return;
      }

      const response = await axios.post(
        `${BASE_URL}/api/pocket/connect-case/`,
        { device_key: caseKey },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        setMessage(`Case ${response.data.case_serial} connected successfully.`);
        setMessageType("success");
        setCaseKey("");
        fetchCases();
      } else {
        setMessage("Error: " + response.data.message);
        setMessageType("error");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setMessage("Error: " + error.response.data.error);
        setMessageType("error");
      } else {
        console.error(error);
        setMessage("Device key not found or conditions not met.");
        setMessageType("error");
      }
    }
  };

  return (
    <div className="my-devices-container">
      <h2 className="my-devices-title">My Devices</h2>

      {/* Add Device Button (commented out) */}
      {/* <Button className="add-device-button" onClick={() => setShowForm(!showForm)}>
        + Add Device
      </Button> */}

      {/* Add Device Form (commented out) */}
      {/* {showForm && (
        <div className="form-container">
          <Input
            className="mb-4"
            placeholder="Device Key"
            value={deviceId}
            onChange={(e) => setDeviceId(e.target.value)}
          />
          <Button className="w-full" onClick={handleAddDevice}>
            Save Device
          </Button>
        </div>
      )} */}

      {/* Add Case Button */}
      {cases.length === 0 && (
        <Button className="add-device-button" onClick={() => setShowCaseForm(!showCaseForm)}>
          + Add a Case
        </Button>
      )}

      {/* Add Case Form */}
      {showCaseForm && (
        <div className="form-container">
          <Input
            className="mb-4"
            placeholder="Device Key"
            value={caseKey}
            onChange={(e) => setCaseKey(e.target.value)}
          />
          <Button className="w-full" onClick={handleAddCase}>
            Save Case
          </Button>
        </div>
      )}

      {/* Success/Error Message Banner */}
      {message && (
        <div className={`message-banner ${messageType}`}>
          {message}
        </div>
      )}

      {/* Glass Devices Table */}
      <h3 className="my-devices-subtitle">Glass</h3>
      <div className="device-table-wrapper">
        <table className="device-table">
          <thead>
            <tr>
              <th>Serial</th>
            </tr>
          </thead>
          <tbody>
            {devices.length > 0 ? (
              devices.map((device) => (
                <tr key={device.serial}>
                  <td>{device.serial}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="1" className="no-devices">
                  No devices available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Cases Table */}
      <h3 className="my-devices-subtitle">Case</h3>
      <div className="device-table-wrapper">
        <table className="device-table">
          <thead>
            <tr>
              <th>Serial</th>
            </tr>
          </thead>
          <tbody>
            {cases.length > 0 ? (
              cases.map((c) => (
                <tr key={c.serial}>
                  <td>{c.serial}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="1" className="no-devices">
                  No cases available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyDevices;
